import React, { MouseEvent, ReactNode, useState } from 'react';
import { Text, Title } from '@/components/typography';
import WhitePaper from '@/components/elevation/WhitePaper/WhitePaper';
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from '@/components/accordion';

import MapPinLineIcon from '@/components/icons/MapPinLineIcon/MapPinLineIcon';
import PhoneNumber from '../../../../../components/navigation/ContactMenu/PhoneNumber/PhoneNumber';
import { MapContainer } from './Aside.styles';
import Image from '@/providers/Image';
import { useFormContatoContext } from '@/features/forms/FormContato/context';

export interface AsideProps {
  className?: string;
  children?: ReactNode;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void | undefined;
}

const Aside = ({ children, ...props }: AsideProps) => {
  const { data, params } = useFormContatoContext();
  const { officePhonesList } = data;
  const [open, setOpen] = useState<string[]>(['']);

  const toggle = (id: string, event: React.MouseEvent<HTMLButtonElement>) => {
    if (open.includes(id)) {
      setOpen((prevState) => [...prevState.filter((accordionId) => accordionId !== id)]);
    } else {
      setOpen((prevState) => [...prevState, id]);
    }
  };

  return (
    <WhitePaper sticky={5}>
      <Title as="h3" textCase="uppercase" color="secondary_500" size="lg" margin="base">
        Nosso Atendimento
      </Title>
      <Accordion open={open} toggle={toggle}>
        {officePhonesList.map((office) => (
          <AccordionItem key={office.id}>
            <AccordionHeader targetId={office.id}>
              <MapPinLineIcon width={16} />
              <span>{office.region}</span>
            </AccordionHeader>
            <AccordionBody targetId={office.id}>
              <Text>{office.openingHours}</Text>
              <PhoneNumber displayType="landline" phoneNumberList={office.phoneNumberList as [PhoneItem]} />
              <Text weight="bold">Como chegar</Text>
              <Text size="sm">{office.address.street}</Text>
              <MapContainer href={office.address.mapsLink} rel="noopener noreferrer" target="_blank">
                <Image src={office.address.mapsImage} alt={`Mapa escritório ${office.region}`} fill />
              </MapContainer>
            </AccordionBody>
          </AccordionItem>
        ))}
      </Accordion>
    </WhitePaper>
  );
};

export default Aside;
